import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { browserRouter } from "./app/router";
import { ThemeSync } from "./components/layout/ThemeSync";
import { ApiProvider } from "./contexts/ApiContext";
import { SecurityProvider } from "./contexts/SecurityContext";
import { ToastProvider } from "./contexts/ToastContext";
import { I18nProvider } from "./lib/i18n/context";
import { QueryProvider } from "./lib/providers/query-provider";
import { clearChunkReloadMarker, installChunkRecoveryListeners } from "./lib/chunk-recovery";

installChunkRecoveryListeners();
clearChunkReloadMarker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nProvider>
    <SecurityProvider>
      <ApiProvider>
        <ToastProvider>
          <QueryProvider>
            <ThemeSync />
            <RouterProvider router={browserRouter} />
          </QueryProvider>
        </ToastProvider>
      </ApiProvider>
    </SecurityProvider>
  </I18nProvider>
);
